import React, { useState } from "react";
import { Popover } from "react-tiny-popover";
import { WardObject } from "../../Map/types";
import { wardAreaColors, wardColors } from "./WardToolButton";
import { MiniWard } from "@shared/Toolbar/WardButton/MiniWard";
import { PopoverContent } from "@shared/components/PopoverContent";

interface WardSelectorPopupProps {
	currentColor: WardObject["color"];
	currentArea: WardObject["areaColor"];
	onSelect: (color: WardObject["color"], area: WardObject["areaColor"]) => void;
}

const WardSelectorPopup: React.FC<WardSelectorPopupProps> = (props) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleSelect = (color: string, area: string) => {
		setIsOpen(false);
		props.onSelect(color as WardObject["color"], area as WardObject["areaColor"]);
	};

	return (
		<>
			<Popover
				isOpen={isOpen}
				positions={["right"]}
				content={
					<PopoverContent>
						<WardOptions
							currentArea={props.currentArea}
							currentColor={props.currentColor}
							onSelect={handleSelect}
						/>
					</PopoverContent>
				}
				onClickOutside={() => setIsOpen(false)}
			>
				<div className={"absolute -right-2 -bottom-2"}>
					<div
						onClick={() => setIsOpen(!isOpen)}
						className={
							"border border-slate-400 w-3 h-3 rounded-full m-2 hover:cursor-pointer"
						}
						style={{ background: wardColors[props.currentColor] }}
					></div>
				</div>
			</Popover>
		</>
	);
};

interface SelectorProps {
	currentColor: WardObject["color"];
	currentArea: WardObject["areaColor"];
	onSelect: (color: string, area: string) => void;
}

export const WardOptions: React.FC<SelectorProps> = (props) => {
	return (
		<>
			{Object.entries(wardAreaColors).map(([areaColorKey, areaColor]) => (
				<div key={areaColorKey} className={"flex gap-2"}>
					{Object.entries(wardColors).map(([colorKey, color]) => (
						<MiniWard
							key={colorKey}
							onClick={() => props.onSelect(colorKey, areaColorKey)}
							selected={
								props.currentColor === colorKey &&
								props.currentArea === areaColorKey
							}
							color={color}
							areaColor={areaColor}
						/>
					))}
				</div>
			))}
		</>
	);
};

export { WardSelectorPopup };
